module.exports = __webpack_public_path__ + "static/city_watch-01cf80c2682c14498e669831d0f060c2.png";